// Action enums
export enum ActionTypes {
  SET_DARK_MODE = 'SET_DARK_MODE',
}
